var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.upcomingMarkets && _vm.upcomingMarkets.length)?_c('div',{staticClass:"upcoming-match"},[_c('v-sheet',{staticClass:"px-4 padding-fix",attrs:{"tile":""}},[_c('section-head',{attrs:{"title":"Upcoming","theme":"white","icon":"mdi-sort-clock-descending","hide-divider":true,"hide-icons":false}})],1),_vm._v(" "),_c('upcoming-matches')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }